// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quill-editor{background-color:#fff;margin-top:30px}.ql-container{font-size:16px}.ql-snow .ql-tooltip{z-index:100}.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before{content:attr(data-value)!important}.ql-snow .ql-color-picker .ql-picker-label:last-child svg{margin-bottom:4px}", ""]);
// Exports
module.exports = exports;
